export default __webpack_public_path__ + "static/media/eyelashes.ec1655ef.png";